import { render, staticRenderFns } from "./vSubmitOrder.vue?vue&type=template&id=27524bcc&"
import script from "./vSubmitOrder.vue?vue&type=script&lang=js&"
export * from "./vSubmitOrder.vue?vue&type=script&lang=js&"
import style0 from "./vSubmitOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports